import React from "react";

const TermsOfServicePage = () => {
  window.location.assign("https://1m-help-docs.s3.us-west-1.amazonaws.com/terms-of-use.html")
  return null
}

export default TermsOfServicePage